import { useEffect } from 'react';
import { useLocation } from 'react-router';

const initialPath = window.location.pathname;

export default function OpenGraphTags() {
    const location = useLocation();
    useEffect(() => {
        if (location.pathname !== initialPath) {
            removeOpenGraphMetaTags();
        }
    }, [location.pathname]);
    return <></>;
}

function removeOpenGraphMetaTags() {
    const title = document.querySelector('meta[name="og:title"]');
    if (title && document.head.contains(title)) document.head.removeChild(title);
    const desc = document.querySelector('meta[name="og:description"]');
    if (desc && document.head.contains(desc)) document.head.removeChild(desc);
}
